/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
$(document).ready(function() {
  	//console.log('custom.js');
  
    $('body').on('click', '[name="register"]', function() {
       if ($('#agree').is(':checked')) {
        $(this).submit();
       }
       else {
        alert("You must agree with the terms and conditions.");
        return false;
      }
    });
  
    $('.faq-block').on('click', '.question a', function(e) {
       console.log('clicked collapse');
       e.stopPropagation();
       var link = $(this).attr('href');
       $('' + link).toggleClass('in')
       $(this).next().slideToggle('fast');
//        $(".footer-block-content").not($(this).next()).hide('fast');
    });
  
    function footerHide() {
      if ( $('body').width() > 768 ) {
        $(".footer-block-content").show();
      } else {
        $(".footer-block-content").hide();
        $('#footer').find('.togglecontent').click(function(){
          $(this).next().slideToggle('fast');
          $(".footer-block-content").not($(this).next()).hide('fast');
        });
        $('.community-side-bar .community-category-title').click(function(){
          $('.community-category').slideToggle('fast');
//           $(".footer-block-content").not($(this).next()).hide('fast');
        });
      }
    }
  
    footerHide();
  
  function community_filter(){
  	$('#community-blocks .block').hide();
    let role = $('#community-roles li a.active').text().toLowerCase();
    let country = $('#community-countries li a.active').text().toLowerCase();
    $('#community-blocks .block').each(function(){
    	let role_block = $(this).find('.community-role').text().toLowerCase();
        let category_1 = $(this).find('.community-category-1').text().toLowerCase();
      	let category_2 = $(this).find('.community-category-2').text().toLowerCase();
      	let country_block = $(this).find('.community-country').text().toLowerCase();
      if(role.includes('all')){
          
          if(country.includes('all')){
              $(this).show();
          }
          else{
              if(country == country_block){
                $(this).show();
              }	
          }
      }
      else if(country.includes('all')){
      	  if(role.includes('all')){
                $(this).show();
          }
          else{
              if(role == role_block || category_1 == role || category_2 == role){
                $(this).show();
              }	
          }
      }
      else{
        	if((role == role_block || category_1 == role || category_2 == role) && (country == country_block)){
              $(this).show();
            }	
        }
    })
  }
  
  $('#community-roles li a').click(function(e){
    e.preventDefault();
    e.stopPropagation();
  	let role = $(this).text().toLowerCase();
    $('#community-roles li a').removeClass('active');
    $(this).addClass('active');
	 community_filter();
  })
  
  $('#community-countries li a').click(function(e){
    e.preventDefault();
    $('#community-countries li a').removeClass('active');
  	let country = $(this).text().toLowerCase();
    $(this).addClass('active');
	community_filter();
  })
  
  $('.question a.collapsed').click(function(e){
  	e.preventDefault();
  })
  
  if ($('.MegaMenu .MegaMenu__Item a[href^="#"').length > 0 ) {
    $( '.MegaMenu .MegaMenu__Item a[href^="#"' ).addClass('disabled-link');
    $( ".MegaMenu .MegaMenu__Item a:contains('_')" ).attr("style", "color: #ffffff !important");
  	$( '.MegaMenu .MegaMenu__Item a[href^="#"' ).click(function(e){
  		e.preventDefault();
  	});
  }
  
  if ($('.Product__AsideB').length > 0 ) {
    var productInfoHeight = $('.Product__Info').height() - 80;
  	$('.Product__Wrapper').css('min-height', productInfoHeight + 'px')
  }
  
  
  $('iframe').load( function() {
    //console.log('iframe');
    $('iframe').contents().find("head")
        .append($("<style type='text/css'>  .shopify-buy__product__compare-price{display: none !important;}  </style>"));
  });
  
  
  
});

Cookies.set('kinzzi_domain', 'kinzzi.com')
Cookies.get('kinzzi_domain');

if (Cookies.get('kinzzi_domain')=='kinzzi.com_') {
	
}